import styled from "@emotion/styled"

export const MainContainer = styled.div`
  margin-top: 59px;
`

export const MembersContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  @media (max-width: 1300px) {
    grid-template-columns: auto auto auto auto;
  }
  @media (max-width: 938px) {
    grid-template-columns: auto auto auto;
  }
  @media (max-width: 700px) {
    grid-template-columns: auto auto;
  }
  @media (max-width: 500px) {
    grid-template-columns: auto;
  }
`
export const MemberImage = styled.div`
  background-image: url(${props => props.image});
  height: 359px;
  background-size: cover;
  padding-top: 20px;
  padding-left: 20px;
`
export const Occupation = styled.div`
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1em;
  color: #4f3ec8;
`
export const Name = styled.div`
  font-family: Poppins, sans-serif;
  font-size: 20px;
  color: #ffffff;
  font-weight: 700;
  margin-top: 3px;
`

export const CommitteeHeading = styled.div`
  font-size: 40px;
  line-height: 1.125em;
  font-weight: 700;
  color: #000;
  text-align: center;
  font-family: Montserrat;
  margin-bottom: 40px;

  @media (max-width: 500px) {
    font-size: 30px;
  }
`
